/// <reference path="WebService.ts" />


interface WebService
{    
    exportWineCellarProducts( target:any, completion:any ) : void;
}

WebService.prototype.exportWineCellarProducts = function( target:any, completion:any ){
    const cmd = new WebServiceCommand(this.integratorURL, "/schema/" + this.scheme + "/Product/export", true, null, "products.xlsx");
    cmd.method = "GET";

    cmd.execute(this, function (code:number, data:any) {
        //TODO: Show error
        if (code != 200 ) {
            AppHelper.showErrorMessage(null, "ERROR", "COULDN'T DOWNLOAD PDF. PLEASE CHECK IF YOU HAVE AN ACTIVE TEMPLATE");
        }
    });   
}
